import { createAsyncThunk } from "@reduxjs/toolkit";
import { GetVouchersPromocodesByIdParams, GetVouchersPromocodesByIdResponse } from "api/api/vouchersApi/types";
import { VouchersAPI } from "api/api/vouchersApi/vouchersApi";
import axios from "axios";

export const getVouchersPromocodesById = createAsyncThunk<
  GetVouchersPromocodesByIdResponse,
  GetVouchersPromocodesByIdParams
>(
  `vouchers/getVouchersPromocodesById`,
  async ({ promocodeId, ...params }, { rejectWithValue }) => {
    try {
      const data = await VouchersAPI.getVouchersPromocodesById({ promocodeId, ...params });
      return data;
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        console.error(
          "Error while getting vouchers promocodes by id",
          error?.response?.data
        );
        return rejectWithValue(error?.response?.data || "Unknown error");
      } else {
        console.error("Error while getting vouchers promocodes by id", error);
        return rejectWithValue(
          "Что-то пошло не так... Попробуйте обновить страницу"
        );
      }
    }
  }
);